import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  {
    id: "1",
    name: "Mpho Mafolo",
    title: "Head Coach · CAF C Licensed",
    bio: "Leading sessions and match-day strategy for the academy's development squads.",
    image: "/coaches/mpho.jpg",
  },
  {
    id: "2",
    name: "Morgan Seroue",
    title: "Senior Coach · CAF B Licensed",
    bio: "Driving technical and tactical development across our older age groups.",
    image: "/coaches/morgan.jpg",
  },
  {
    id: "3",
    name: "Howard Mathunjwa",
    title: "Goalkeeping Coach",
    bio: "Specialist in modern goalkeeping — distribution, footwork and shot-stopping under pressure.",
    image:
      "https://images.unsplash.com/photo-1748111989296-eb3bb75d4ff3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxzb2NjZXIlMjBjb2FjaCUyMGluc3RydWN0aW5nJTIwcGxheWVyc3xlbnwwfHx8fDE3Nzc0NDI1NDB8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "4",
    name: "Lucky Nkosi",
    title: "Strength & Conditioning Coach",
    bio: "Building athletic foundations: speed, agility, durability and injury prevention.",
    image:
      "https://images.pexels.com/photos/8941613/pexels-photo-8941613.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "5",
    name: "Randy Mahlangu",
    title: "Team Manager · Sports Management Diploma",
    bio: "Running operations, logistics and player welfare across every age group.",
    image:
      "https://images.pexels.com/photos/3148452/pexels-photo-3148452.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export default function Coaches() {
  const [coaches, setCoaches] = useState(FALLBACK);

  useEffect(() => {
    axios
      .get(`${API}/coaches`)
      .then((r) => Array.isArray(r.data) && r.data.length && setCoaches(r.data))
      .catch(() => {});
  }, []);

  return (
    <section
      id="coaches"
      data-testid="coaches-section"
      className="relative py-24 lg:py-36 px-6 lg:px-10"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16 fade-up">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-red-600" />
              <span className="text-xs uppercase tracking-[0.3em] text-red-600">
                The Bench
              </span>
            </div>
            <h2
              data-testid="coaches-title"
              className="font-heading uppercase text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight"
            >
              Coaches & <br />
              <span className="text-red-600">Staff.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/60 leading-relaxed">
            Qualified coaches and dedicated management — every member CAF or
            sports-management certified.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {coaches.map((c, idx) => (
            <div
              key={c.id}
              data-testid={`coach-card-${c.id}`}
              className="group fade-up"
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <div className="relative aspect-[3/4] overflow-hidden rounded-xl bg-neutral-900 border border-white/10">
                <img
                  src={c.image}
                  alt={c.name}
                  className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent opacity-80" />
                <div className="absolute top-4 left-4 text-xs uppercase tracking-widest text-red-600">
                  0{idx + 1}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="text-[10px] uppercase tracking-[0.2em] text-red-600 mb-1">
                    {c.title}
                  </p>
                  <h3 className="font-heading uppercase text-xl lg:text-2xl tracking-tight leading-none text-white mb-2">
                    {c.name}
                  </h3>
                  <p className="text-xs text-white/70 leading-relaxed line-clamp-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    {c.bio}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
